import React from 'react'

export const MobileMenu = () => {
  return (
  <div className="menu_mobile menu_mobile_fullscreen scheme_dark">
        <div className="menu_mobile_inner with_widgets">
          <div className="menu_mobile_header_wrap">
            <a
              className="sc_layouts_logo"
              href="/"
            >
              <img
                loading="lazy"
                src="https://d3ijvsxxdvm5iq.cloudfront.net/assets/imges/logoo-01.png"
                // srcSet="//agricola.axiomthemes.com/wp-content/uploads/2022/07/logo-inverse-retina-300x92.png 2x"
                alt="Agricola"
                width={173}
                height={53}
              />{" "}
            </a>
            <a className="menu_mobile_close menu_button_close" tabIndex={0}>
              <span className="menu_button_close_text">Close</span>
              <span className="menu_button_close_icon" />
            </a>
          </div>
          <div className="menu_mobile_content_wrap content_wrap">
            <div className="menu_mobile_content_wrap_inner">
              <nav className="menu_mobile_nav_area">
                <ul id="mobile-menu_mobile_290249641">
                  <li
                    id="mobile-menu-item-18273"
                    className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-18273"
                  >
                    <a href="#">
                      <span>Home</span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="mobile-menu-item-18274"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-18013 current_page_item menu-item-18274"
                      >
                        <a
                          href="https://agricola.axiomthemes.com/"
                          aria-current="page"
                        >
                          <span>Agriculture</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18275"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18275"
                      >
                        <a href="https://agricola.axiomthemes.com/agro-services/">
                          <span>Agro Services</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18276"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18276"
                      >
                        <a href="https://agricola.axiomthemes.com/dairy-farm/">
                          <span>Dairy Farm</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18279"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18279"
                      >
                        <a href="https://agricola.axiomthemes.com/organic-farm/">
                          <span>Organic Farm</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18277"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18277"
                      >
                        <a href="https://agricola.axiomthemes.com/equipment-store/">
                          <span>Equipment Store</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18278"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18278"
                      >
                        <a href="https://agricola.axiomthemes.com/farm-shop/">
                          <span>Farm Shop</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="mobile-menu-item-17651"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-17651"
                  >
                    <a href="#">
                      <span>Pages</span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="mobile-menu-item-18280"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18280"
                      >
                        <a href="https://agricola.axiomthemes.com/about/">
                          <span>About</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18286"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18286"
                      >
                        <a href="https://agricola.axiomthemes.com/our-services/">
                          <span>Our Services</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18288"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18288"
                      >
                        <a href="https://agricola.axiomthemes.com/testimonials/">
                          <span>Testimonials</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18287"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18287"
                      >
                        <a href="https://agricola.axiomthemes.com/our-team/">
                          <span>Our Team</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18289"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18289"
                      >
                        <a href="https://agricola.axiomthemes.com/pricing/">
                          <span>Pricing</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18290"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18290"
                      >
                        <a href="https://agricola.axiomthemes.com/faq/">
                          <span>FAQ</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-20696"
                        className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-20696"
                      >
                        <a href="#">
                          <span>Tools</span>
                        </a>
                        <ul className="sub-menu">
                          <li
                            id="mobile-menu-item-18291"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18291"
                          >
                            <a href="https://agricola.axiomthemes.com/typography/">
                              <span>Typography</span>
                            </a>
                          </li>
                          <li
                            id="mobile-menu-item-18292"
                            className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18292"
                          >
                            <a href="https://agricola.axiomthemes.com/404-page">
                              <span>404 Page</span>
                            </a>
                          </li>
                          <li
                            id="mobile-menu-item-18294"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18294"
                          >
                            <a href="https://agricola.axiomthemes.com/service-plus/">
                              <span>Service Plus</span>
                            </a>
                          </li>
                          <li
                            id="mobile-menu-item-18293"
                            className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18293"
                          >
                            <a href="https://agricola.axiomthemes.com/newsletter-popup/">
                              <span>Newsletter Popup</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="mobile-menu-item-18295"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18295"
                  >
                    <a href="#">
                      <span>Portfolio</span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="mobile-menu-item-18296"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18296"
                      >
                        <a href="https://agricola.axiomthemes.com/portfolio-1/">
                          <span>Portfolio 1</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18297"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18297"
                      >
                        <a href="https://agricola.axiomthemes.com/portfolio-2/">
                          <span>Portfolio 2</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18298"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18298"
                      >
                        <a href="https://agricola.axiomthemes.com/portfolio-3/">
                          <span>Portfolio 3</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="mobile-menu-item-18299"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18299"
                  >
                    <a href="https://agricola.axiomthemes.com/blog/">
                      <span>Blog</span>
                    </a>
                  </li>
                  <li
                    id="mobile-menu-item-18300"
                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-18300"
                  >
                    <a href="#">
                      <span>Shop</span>
                    </a>
                    <ul className="sub-menu">
                      <li
                        id="mobile-menu-item-18301"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18301"
                      >
                        <a href="https://agricola.axiomthemes.com/shop/">
                          <span>Product List</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18302"
                        className="menu-item menu-item-type-post_type menu-item-object-product menu-item-18302"
                      >
                        <a href="https://agricola.axiomthemes.com/product/green-apple/">
                          <span>Product Single</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18303"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18303"
                      >
                        <a href="https://agricola.axiomthemes.com/cart/">
                          <span>Cart</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-18304"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18304"
                      >
                        <a href="https://agricola.axiomthemes.com/checkout/">
                          <span>Checkout</span>
                        </a>
                      </li>
                      <li
                        id="mobile-menu-item-21045"
                        className="menu-item menu-item-type-post_type menu-item-object-page menu-item-21045"
                      >
                        <a href="https://agricola.axiomthemes.com/wishlist-page/">
                          <span>Wishlist Page</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    id="mobile-menu-item-17194"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-17194"
                  >
                    <a href="https://agricola.axiomthemes.com/contacts/">
                      <span>Contact US</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="socials_mobile">
                <a
                  target="_blank"
                  href="https://www.facebook.com/AxiomThemes/"
                  className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons"
                >
                  <span
                    className="social_icon social_icon_facebook-1"
                    style={{}}
                  >
                    <span className="icon-facebook-1" />
                  </span>
                </a>
                <a
                  target="_blank"
                  href="https://twitter.com/ThemesAxiom"
                  className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons"
                >
                  <span
                    className="social_icon social_icon_twitter-new"
                    style={{}}
                  >
                    <span className="icon-twitter-new" />
                  </span>
                </a>
                <a
                  target="_blank"
                  href="https://dribbble.com/AxiomThemes"
                  className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons"
                >
                  <span
                    className="social_icon social_icon_dribble-new"
                    style={{}}
                  >
                    <span className="icon-dribble-new" />
                  </span>
                </a>
                <a
                  target="_blank"
                  href="https://www.instagram.com/axiom_themes/"
                  className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons"
                >
                  <span
                    className="social_icon social_icon_instagram"
                    style={{}}
                  >
                    <span className="icon-instagram" />
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="menu_mobile_widgets_area">
            <div className="widgets_additional_menu_mobile_fullscreen widgets_additional_menu_mobile_fullscreen_wrap widget_area">
              <div className="widgets_additional_menu_mobile_fullscreen_inner widgets_additional_menu_mobile_fullscreen_inner widget_area_inner">
                <aside className="widget_text widget widget_custom_html">
                  <div className="textwidget custom-html-widget">
                    <div className="extra_item">
                      <h6>Have a Project?</h6>
                      <a href="/cdn-cgi/l/email-protection#9ff6f1f9f0dfe8fafdecf6ebfab1fcf0f2">
                        <span
                          className="__cf_email__"
                          data-cfemail="e48d8a828ba4938186978d9081ca878b89"
                        >
                          [email&nbsp;protected]
                        </span>
                      </a>
                    </div>
                    <div className="extra_item">
                      <h6>Want to Work With Us?</h6>
                      <a href="https://agricola.axiomthemes.com/about/">
                        Send Brief
                      </a>
                    </div>
                    <div className="extra_item">
                      <h6>Want to Buy Products?</h6>
                      <a href="https://agricola.axiomthemes.com/shop/">
                        Go to Shop
                      </a>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}
